<template>
    <loader-overlay-logo></loader-overlay-logo>
</template>

<script>

import LoaderOverlayLogo from '../General/LoaderOverlayLogo.vue';
import HandlesFilters from "../../Mixins/HandlesFilters.js";

export default {

    name: 'OverviewDataHandler',

    mixins: [HandlesFilters],

    props: ['prefix', 'actionMode', 'viewMode', 'primarySegments', 'defaultPrefix', 'hiddenSegments'],

    components: {
        LoaderOverlayLogo,
    },

    data() {
        return {
            lastUrl: null,//to prevent we keep adding the same url to the history
            selectedFilters: {},
            clearFilters: {},
            mode: 'filter-only',//or render
            primaryFilterSegments: [],
            prefixUrl: this.prefix,
        }
    },

    created() {
        this.mode = this.actionMode ?? this.mode;
        this.primaryFilterSegments = JSON.parse(this.primarySegments);
    },

    mounted() {
        addEventListener('popstate', (event) => {
            if (event.state && event.state.filters) {
                const list = [];

                event.state.filters.forEach(html => {
                    let filter = document.createElement('div');
                    filter.innerHTML = html;
                    list.push(filter.firstChild);
                });

                this.buildSelectedFilters(list);
            }

            this.buildUrl();
            this.getData(false);
        });

        this.Bus.on('filter-change', (cancels = null) => {
            if (cancels !== null) {
                this.cancel(cancels);
            }

            this.buildAll();
            this.getData();
        });

        this.Bus.on('set-clear-filter', (data) => {
            this.setClearFilter(data);
        });

        this.Bus.on('clear-filter', (data) => {
            this.clearFilter(data);
        });

        this.Bus.on('clear-all-filters', () => {
            this.clearAllFilters();
        });

        this.Bus.on('paginate', (string) => {
            this.paginate(string);
        });

        this.Bus.on('update-render-mode', mode => {
            this.mode = mode;
        });

        this.$nextTick(() => {
            if (window.location.hash === '#mapView') {

                //laughable
                setTimeout(() => this.Bus.emit('open-maps-popup'), 200);
            }
        });
    },

    methods: {

        getData(enableHistory = true) {

            this.Bus.emit('filters-start-loading', this.url);
            this.Bus.emit('start-loading', 'filters');

            axios.post(this.url)
                .then(response => {

                    if (this.mode === 'render') {

                        this.Bus.emit('render-view', {
                            reference: 'overview-filters',
                            content: response.data.content.filters,
                            loader: false,
                        });

                        this.Bus.emit('render-view', {
                            reference: 'overview-results',
                            content: response.data.content.results,
                            loader: false,
                        });

                        this.Bus.emit('render-view', {
                            reference: 'overview-seo',
                            content: response.data.content.seo,
                            loader: false,
                        });

                        this.Bus.emit('render-view', {
                            reference: 'overview-breadcrumbs',
                            content: response.data.content.breadcrumbs,
                            loader: false,
                        });

                    }

                    if (typeof response.data.metaData !== 'undefined') {
                        this.setMetaData(response.data.metaData);
                    }

                    this.Bus.emit('update-filters', response.data.filters);
                    this.Bus.emit('update-sorting', response.data.sorting);
                    this.Bus.emit('stop-loading', 'filters');

                    this.clearAll();

                })
                .finally(() => {
                    const filters = [];

                    document.querySelectorAll('[data-filter-reference]').forEach(
                        node => filters.push(node.outerHTML)
                    );

                    // The default prefix !== undefined check prevents history items from being pushed on the homepage.
                    if (enableHistory && this.defaultPrefix !== undefined && this.url !== this.lastUrl) {

                        this.lastUrl = this.url;

                        history.pushState({filters: filters}, null, this.url);
                    }
                })
                .catch(error => {

                    console.log('ERROR:');
                    console.log(error);

                });
        },

        setMetaData(data) {

            //set title
            document.title = data.default.title;

            //set description
            document.querySelector('meta[name="description"]').setAttribute("content", data.default.description);

            //set canonical
            let canonical = document.querySelector('link[rel="canonical"]');
            if (data.canonical && canonical) {
                canonical.setAttribute("href", data.canonical);
            }

            //set rel nextF/prev
            let relNext = document.querySelector('link[rel="next"]');
            if (data.relNext && relNext) {
                relNext.setAttribute("href", data.relNext);
            }

            let relPrev = document.querySelector('link[rel="prev"]');
            if (data.relPrev && relPrev) {
                relPrev.setAttribute("href", data.relPrev);
            }
        },

        setClearFilter(data) {

            //replace with default instead of clearing
            if (data.cancelReplaceValue) {

                const filterTarget = document.querySelector('[data-filter-reference="' + data.categories + '"]');

                if (filterTarget) {
                    filterTarget.setAttribute("data-selected-value", data.cancelReplaceValue);
                }

                this.buildAll();
                this.getData();

            } else {

                const categories = data.categories.split(',');

                categories.forEach(category => {
                    this.clearFilters[category] = []
                    this.clearFilters[category].push(data.reference);
                })

                if (data.cancels) {
                    this.cancel(data.cancels);
                }
            }
        },

        clearFilter(data) {

            //exception because it's complicated
            // if (data.categories === 'budget') {
            //     return;
            // }

            this.setClearFilter(data);

            this.buildAll();
            this.getData();
        },

        cancel(data) {
            data.split(',').forEach(item => {

                if (item.includes(":")) {

                    let [key, value] = item.split(":");

                    this.clearFilters[key] = [value];
                } else {
                    this.clearFilters[item] = [];
                }
            });
        },

        clearAllFilters() {
            this.Bus.emit('filters-start-loading');
            this.clearAll();
            this.buildUrl();
            this.getData();
        },

        paginate(string) {
            this.paginationString = string;
            this.buildAll();
            this.getData();
            window.scrollTo({top: 0, behavior: 'smooth'});
        },

        clearAll() {
            this.selectedFilters = {};
            this.clearFilters = {};
            this.paginationString = null;
        },
    },
}

</script>

